import { Component, EventEmitter, Input, Output } from '@angular/core';
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'pt-two-factor-authentication-notification',
  template: `
    <div class="modal-header">
      <h4 class="modal-title">
        {{ 'TWO_FACTOR_AUTHENTICATION.NOTIFICATION.TITLE' | translate }}
      </h4>
    </div>
    <div class="modal-body">
      <div class="notification">
        <img src="assets/images/otp/example.jpg" alt="'example'" />
        <pt-image-with-text
          class="w-100"
          [image]="'assets/images/otp/key.png'"
          [texts]="[enabledMessage]"
        >
        </pt-image-with-text>
        <pt-image-with-text
          class="w-100"
          [image]="'assets/images/otp/account.png'"
          [texts]="[profileMessage]"
        >
        </pt-image-with-text>
      </div>
    </div>
    <div class="modal-footer">
      <ng-container *ngIf="forceConfiguration; else defaultActions">
        <button
          type="button"
          class="btn btn-primary btn-sm"
          (click)="pressConfigure.emit(true); $event.stopPropagation()"
        >
          {{ 'BUTTON.CONFIGURE' | translate }}
        </button>
        <button
          ngbAutofocus
          type="button"
          class="btn btn-outline-secondary btn-sm"
          (click)="logout.emit(true); $event.stopPropagation()"
        >
          {{ 'BUTTON.LOGOUT' | translate }}
        </button>
      </ng-container>

      <ng-template #defaultActions>
        <button
          type="button"
          class="btn btn-primary btn-sm"
          (click)="pressProfile.emit(true); $event.stopPropagation()"
        >
          {{ 'BUTTON.GO_TO_PROFILE' | translate }}
        </button>

        <button
          ngbAutofocus
          type="button"
          class="btn btn-outline-secondary btn-sm"
          (click)="pressCancel.emit(true); $event.stopPropagation()"
        >
          {{ 'BUTTON.CANCEL' | translate }}
        </button>
      </ng-template>
    </div>
  `,
  styles: [
    `
      .notification {
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
      }

      .notification img {
        width: 450px;
        margin-bottom: 15px;
      }
    `,
  ],
})
export class TwoFactorAuthenticationNotificationComponent {
  @Output() pressCancel = new EventEmitter<boolean>();
  @Output() pressProfile = new EventEmitter<boolean>();
  @Output() pressConfigure = new EventEmitter<boolean>();
  @Output() logout = new EventEmitter<boolean>();

  @Input() forceConfiguration: boolean;

  enabledMessage = this.translateService.stream(
    'TWO_FACTOR_AUTHENTICATION.NOTIFICATION.ENABLED_MESSAGE'
  );
  profileMessage = this.translateService.stream(
    'TWO_FACTOR_AUTHENTICATION.NOTIFICATION.PROFILE_MESSAGE'
  );

  constructor(private translateService: TranslateService) {}
}
